import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { tourismClassifiedAPIRoutes } from '../index';

export const sosServices = createApi({
  reducerPath: 'sosServices',
  tagTypes: ['SosTag'],
  baseQuery: fetchBaseQuery({
    baseUrl: tourismClassifiedAPIRoutes.baseUrl,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem('jwtToken');
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    }
  }),
  endpoints: (builder) => ({
    getActiveSosAlertsByVendor: builder.query<any[], number>({
      query: (vendorId) => ({
        url: `sos/vendor/${vendorId}`,
        method: 'GET'
      }),
      providesTags: ['SosTag']
    }),
    getAllActiveSosAlerts: builder.query<any[], void>({
      query: () => ({
        url: `sos/active`,
        method: 'GET'
      }),
      providesTags: ['SosTag']
    }),
    resolveSosAlert: builder.mutation<boolean, number>({
      query: (id) => ({
        url: `sos/resolve/${id}`,
        method: 'PUT'
      }),
      invalidatesTags: ['SosTag']
    })
  })
});

export const {
  useGetActiveSosAlertsByVendorQuery,
  useGetAllActiveSosAlertsQuery,
  useResolveSosAlertMutation
} = sosServices;
